// ================================================================
// contact-persons-edit — modiriat-e rabet-ha (Ansprechpartner) dar
// modal-e virayesh-e moshtari. jodaganeh az CompanyDashboard.js.
//
// state: s.cust2Edit.persons = [{ id?, name, email, phone, role, _deleted? }]
//   - id nadarad  => rabet-e jadid (create)
//   - _deleted    => hazf (delete agar id dashte bashad)
//   - id + taghyir => update
// origin: s.cust2Edit._personsOrigin (snapshot-e avvaliye baraye moqayese)
// ================================================================
import { icon, escapeHtml } from '../../utils/dom.js';
import { createContactPerson, updateContactPerson, deleteContactPerson } from '../../core/customers.js';

// snapshot-e avvaliye + array-e ghabel-e virayesh ra amade mikonad (moqe-ye baz-shodan-e modal)
export function initEditPersons(customer) {
  const src = (customer && Array.isArray(customer.persons)) ? customer.persons : [];
  // copy-ye amigh ta virayesh ru-ye asl asar nagozarad
  const persons = src.map(p => ({ id: p.id, name: p.name || '', email: p.email || '', phone: p.phone || '', role: p.role || '' }));
  const origin = src.map(p => ({ id: p.id, name: p.name || '', email: p.email || '', phone: p.phone || '', role: p.role || '' }));
  return { persons, origin };
}

// controlled input baraye field-haye rabet dar modal-e virayesh
export function editPersonField(idx, field, value) {
  const arr = window.__cust2EditPersonsRef;
  if (arr && arr[idx] && field in arr[idx]) arr[idx][field] = value;
}

// HTML-e bخsh-e rabet-ha dar modal-e virayesh
export function editPersonsHtml(persons) {
  const list = Array.isArray(persons) ? persons.filter(p => !p._deleted) : [];
  return `
    <div class="cust-persons-section cd-cust2-edit-persons">
      <div class="cust-persons-head">
        <span class="cust-persons-title">${icon('group', 15)}<span>Ansprechpartner</span></span>
        <button class="cust-persons-add" data-action="cust2-edit-person-add" type="button">${icon('add', 15)}<span>Hinzufügen</span></button>
      </div>
      ${list.length ? list.map((p) => {
        const realIdx = persons.indexOf(p);
        return `
        <div class="cust-person-card">
          <button class="cust-person-del" data-action="cust2-edit-person-remove" data-idx="${realIdx}" type="button" aria-label="Entfernen">${icon('close', 15)}</button>
          <input class="cd-cust2-edit-input cust-person-in" data-edit-person-idx="${realIdx}" data-edit-person-field="name" type="text" autocomplete="off" placeholder="Name" value="${escapeHtml(p.name || '')}" />
          <input class="cd-cust2-edit-input cust-person-in" data-edit-person-idx="${realIdx}" data-edit-person-field="role" type="text" autocomplete="off" placeholder="Funktion (z.B. Projektleiter)" value="${escapeHtml(p.role || '')}" />
          <input class="cd-cust2-edit-input cust-person-in" data-edit-person-idx="${realIdx}" data-edit-person-field="phone" type="tel" inputmode="tel" autocomplete="off" placeholder="Telefon" value="${escapeHtml(p.phone || '')}" />
          <input class="cd-cust2-edit-input cust-person-in" data-edit-person-idx="${realIdx}" data-edit-person-field="email" type="email" inputmode="email" autocomplete="off" autocapitalize="off" spellcheck="false" placeholder="E-Mail" value="${escapeHtml(p.email || '')}" />
        </div>`;
      }).join('') : '<div class="cust-persons-empty">Keine Ansprechpartner</div>'}
    </div>`;
}

// moqayese-ye persons ba origin va ersal be backend (create/update/delete)
// contactId: id-e moshtari. baraye har rabet, org-scope dar backend anjam mishavad.
export async function saveEditPersons(contactId, persons, origin) {
  const cur = Array.isArray(persons) ? persons : [];
  const org = Array.isArray(origin) ? origin : [];

  // 1) hazf: har rabeti ke dar origin bud (id dasht) vali alan _deleted ast ya dar list nist
  const curIds = new Set(cur.filter(p => p.id && !p._deleted).map(p => p.id));
  for (const o of org) {
    if (o.id && !curIds.has(o.id)) {
      try { await deleteContactPerson(o.id); } catch (_) {}
    }
  }

  // 2) create + update
  for (const p of cur) {
    if (p._deleted) continue;
    const nm = (p.name || '').trim();
    const em = (p.email || '').trim();
    const ph = (p.phone || '').trim();
    const ro = (p.role || '').trim();
    const isEmpty = !nm && !em && !ph && !ro;

    if (!p.id) {
      // jadid — faghat agar khali nist
      if (!isEmpty) {
        try { await createContactPerson(contactId, { name: nm, email: em, phone: ph, role: ro }); } catch (_) {}
      }
      continue;
    }
    // mojood — agar taghyir karde, update kon
    const before = org.find(o => o.id === p.id);
    const changed = !before || before.name !== nm || before.email !== em || before.phone !== ph || before.role !== ro;
    if (changed) {
      try { await updateContactPerson(p.id, { name: nm, email: em, phone: ph, role: ro }); } catch (_) {}
    }
  }
}
